export default "__VITE_ASSET__Dpe3lXAS__"